import { axios } from './base-api'

const loginApplicant = async (applicant) => {
    return await axios
        .post(`/api/login`, applicant);
};

const loginRecruiter = async (recruiter) => {
    return await axios
        .post(`/api/recruiter/login`, recruiter);
};

const registerApplicant = async (data) => {
    return await axios
        .post(`/api/register`, data);
};

export {
    loginApplicant,
    loginRecruiter,
    registerApplicant
};